import Vue from "vue";
import VueI18n from "vue-i18n";
import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import { localeChanged } from "vee-validate";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "eng",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "est",
  silentTranslationWarn: true,
  messages: {},
});

const loadedLanguages = [];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

const setDataToObject = (labels) => {
  const labelsHashMap = {
    est: {},
    eng: {},
    rus: {},
  };

  for (const label of labels) {
    if (label.est) {
      labelsHashMap.est[label.keyword] = label.est;
    }
    if (label.eng) {
      labelsHashMap.eng[label.keyword] = label.eng;
    }
    if (label.rus) {
      labelsHashMap.rus[label.keyword] = label.rus;
    }
  }

  return labelsHashMap;
};

/**
 * fetch labels and switch language
 * @param lang {String} - i18n locale name
 * @return {Promise<void>}
 */
export async function loadLanguageAsync(lang) {
  if (
    loadedLanguages.length &&
    Object.keys(loadedLanguages[0]).includes(lang)
  ) {
    if (i18n.locale !== lang) {
      i18n.locale = lang;
      i18n.setLocaleMessage(lang, loadedLanguages[0][lang]);
      setI18nLanguage(lang);
    }
    return;
  }

  const { data: labels } = await api.get(ENDPOINTS.label);
  const data = setDataToObject(labels.labels);

  loadedLanguages.push(data);
  localeChanged();

  // Set fallback messages to message object
  i18n.setLocaleMessage(
    process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    loadedLanguages[0][process.env.VUE_APP_I18N_FALLBACK_LOCALE]
  );
  i18n.setLocaleMessage(lang, loadedLanguages[0][lang]);

  setI18nLanguage(lang);
}
